import AdminCrud from "@/components/admin/AdminCrud";

export default function AdminTestimonials() {
  return (
    <AdminCrud
      title="Testimonials"
      resource="testimonials"
      defaultItem={{ name: "", location: "", rating: 5, message: "", avatar_url: "", order: 1 }}
      fields={[
        { key: "name", label: "Name" },
        { key: "location", label: "Location" },
        { key: "rating", label: "Rating (1-5)", type: "number" },
        { key: "message", label: "Message", type: "textarea", rows: 3 },
        { key: "avatar_url", label: "Avatar", type: "image" },
        { key: "order", label: "Order", type: "number" },
      ]}
    />
  );
}
